import React from "react";
import _ from "lodash";
import Utils from "../../helpers/Utils";
import { useSelector, useDispatch } from "react-redux";
import { consultationSidebarToggle } from "../../actions/followUpActions";

const ConsultationHistorySidebar = () => {
  const dispatch = useDispatch();
  const { printConsultationTemplates } = useSelector((state) => state.followUp);
  const templatesList = _.get(printConsultationTemplates, "templates", []);

  if (templatesList.length) {
    const cleanedHTML = Utils.cleanTableHTML(
      _.get(printConsultationTemplates, "vitalAnswerHtmlAsString", ""),
    );

    return (
      <div className="consultation-sidebar">
        <button
          type="button"
          className="close-btn"
          onClick={() => dispatch(consultationSidebarToggle(false))}
        >
          &#10005;
        </button>

        {templatesList.map((template, index) => (
          <div
            key={index}
            className="consultation-sidebar__body"
            dangerouslySetInnerHTML={{
              __html: _.get(template, "templateAnswerHtmlAsString", ""),
            }}
          />
        ))}
        <div
          className="medical-fill-in-form-vital_table"
          dangerouslySetInnerHTML={{ __html: cleanedHTML }}
        />
      </div>
    );
  }
  return null;
};

export default ConsultationHistorySidebar;
